var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('color-picker',{attrs:{"p-color":_vm.pColor,"close-on-click-body":true,"show-close":false,"type":"linear"},on:{"changeColor":_vm.changeColor,"onClose":_vm.onClosePicker},model:{value:(_vm.isPickerOpened),callback:function ($$v) {_vm.isPickerOpened=$$v},expression:"isPickerOpened"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }